// SEO local — pages dédiées par ville/arrondissement.
// Chaque ville a un contenu unique, structuré, schema.org friendly.

export const CITIES = {
    "paris-16": {
        slug: "paris-16",
        city: "Paris 16e",
        title: "Rénovation d'appartement à Paris 16e — Haut de gamme",
        intro: "Le 16e arrondissement de Paris concentre quelques-uns des plus beaux appartements haussmanniens et immeubles d'entre-deux-guerres de la capitale. Rénover dans ces immeubles demande méthode, expertise et respect du bâti.",
        focus: "Restauration de parquets en chêne, moulures, cheminées d'origine, intégration discrète des réseaux modernes.",
        landmarks: ["Trocadéro", "Passy", "Auteuil", "Avenue Foch"],
    },
    "paris-7": {
        slug: "paris-7",
        city: "Paris 7e",
        title: "Rénovation haut de gamme dans le 7e arrondissement de Paris",
        intro: "Du Champ-de-Mars au Faubourg Saint-Germain, le 7e abrite des biens d'exception. Notre savoir-faire s'adapte aux contraintes patrimoniales tout en apportant le confort contemporain attendu.",
        focus: "Hauteurs sous plafond, restitution des parquets point de Hongrie, mise aux normes électriques discrète.",
        landmarks: ["Invalides", "Champ-de-Mars", "Saint-Germain", "Rue du Bac"],
    },
    "paris-8": {
        slug: "paris-8",
        city: "Paris 8e",
        title: "Rénovation d'appartement à Paris 8e — Haussmann & prestige",
        intro: "Du parc Monceau aux Champs-Élysées, le 8e arrondissement de Paris est l'écrin d'appartements haussmanniens d'exception. Nos chantiers y conjuguent élégance classique et innovations contemporaines.",
        focus: "Refonte distributive sur grands plateaux, suites parentales sur-mesure, cuisines fermées de prestige.",
        landmarks: ["Parc Monceau", "Triangle d'or", "Madeleine", "Faubourg Saint-Honoré"],
    },
    "paris-6": {
        slug: "paris-6",
        city: "Paris 6e",
        title: "Rénovation d'appartement à Paris 6e — Saint-Germain",
        intro: "Saint-Germain-des-Prés, Odéon, Luxembourg : le 6e arrondissement séduit par ses immeubles anciens, ses petites surfaces optimisées et son raffinement parisien. Nos chantiers y mettent l'accent sur la précision millimétrique.",
        focus: "Optimisation des petites surfaces, mobilier d'ébénisterie sur-mesure, cuisines compactes ultra-finies.",
        landmarks: ["Saint-Germain-des-Prés", "Odéon", "Jardin du Luxembourg"],
    },
    "neuilly-sur-seine": {
        slug: "neuilly-sur-seine",
        city: "Neuilly-sur-Seine",
        title: "Rénovation à Neuilly-sur-Seine — Maisons & appartements",
        intro: "Neuilly-sur-Seine accueille des familles exigeantes dans ses immeubles haussmanniens, ses maisons individuelles et ses penthouses contemporains. Nous y orchestrons des chantiers à la fois ambitieux et discrets.",
        focus: "Coordination tous corps d'état pour rénovations complètes, suites parentales, dépendances et jardins.",
        landmarks: ["Avenue Charles-de-Gaulle", "Île de la Jatte", "Bois de Boulogne"],
    },
    "boulogne-billancourt": {
        slug: "boulogne-billancourt",
        city: "Boulogne-Billancourt",
        title: "Rénovation à Boulogne-Billancourt — Art déco & contemporain",
        intro: "Boulogne-Billancourt offre un patrimoine architectural unique entre Art déco, années 30 et programmes contemporains. Chaque rénovation s'inscrit dans le respect du style d'origine.",
        focus: "Mise en valeur des éléments Art déco, parquets d'origine, fenêtres acier remplacées à l'identique.",
        landmarks: ["Île Seguin", "Parc des Princes", "Rives de Seine"],
    },
    "saint-cloud": {
        slug: "saint-cloud",
        city: "Saint-Cloud",
        title: "Rénovation à Saint-Cloud — Maisons bourgeoises de caractère",
        intro: "Saint-Cloud séduit par ses maisons de caractère, ses villas de prestige et ses vues exceptionnelles sur Paris. Nos rénovations y respectent l'âme du bâti tout en modernisant les équipements.",
        focus: "Restauration de menuiseries anciennes, isolation thermique invisible, intégration domotique sur-mesure.",
        landmarks: ["Parc de Saint-Cloud", "Bord de Seine"],
    },
    "versailles": {
        slug: "versailles",
        city: "Versailles",
        title: "Rénovation à Versailles — Hôtels particuliers & maisons de ville",
        intro: "Versailles est un terrain d'exception pour la rénovation patrimoniale : hôtels particuliers, immeubles XVIIIe, maisons de ville. Nos chantiers exigent un savoir-faire artisanal de premier rang.",
        focus: "Restauration des moulures, restitution patrimoniale, mise aux normes invisible, dialogue avec ABF si nécessaire.",
        landmarks: ["Quartier Notre-Dame", "Saint-Louis", "Domaine de Versailles"],
    },
    "levallois-perret": {
        slug: "levallois-perret",
        city: "Levallois-Perret",
        title: "Rénovation à Levallois-Perret — Appartements contemporains",
        intro: "Levallois-Perret allie immeubles haussmanniens du centre et programmes neufs des bords de Seine. Nous y intervenons sur des rénovations complètes comme sur des optimisations ciblées.",
        focus: "Cuisines ouvertes haut de gamme, dressings sur-mesure, salles de bain spa.",
        landmarks: ["Mairie", "Anatole-France", "Rives de Seine"],
    },
    "paris-17": {
        slug: "paris-17",
        city: "Paris 17e",
        title: "Rénovation d'appartement à Paris 17e — Plaine Monceau & Batignolles",
        intro: "Du Parc Monceau aux Batignolles, le 17e arrondissement de Paris séduit par sa diversité architecturale. Nos chantiers y prennent en compte les copropriétés actives et les exigences de calendrier.",
        focus: "Rénovations en milieu occupé, gestion des nuisances voisinage, restitution parfait achèvement.",
        landmarks: ["Parc Monceau", "Batignolles", "Ternes", "Villiers"],
    },
};

export const CITY_LIST = Object.values(CITIES);
